import Axios from "axios";
import {
  SET_EMPLOYEE_SHIFT_MAPPING_LIST,
  UNSET_EMPLOYEE_SHIFT_MAPPING_LIST,
  SET_EMPLOYEE_SHIFT_MAPPING_DETAILS,
  UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS,
} from "@/store/mutation-types";
import {
  saveEmployeeShiftMapping,
  getEmployeeShiftMappingList,
  getEmployeeShiftMappingDetails,
} from "@/store/api";

const state = {
  employeeShiftMappings: [],
  employeeShiftMappingDetails: null,
};

const getters = {
  getEmployeeShiftMappingList(state) {
    return state.employeeShiftMappings;
  },
  getEmployeeShiftMappingDetails(state) {
    return state.employeeShiftMappingDetails;
  },
};

const mutations = {
  [SET_EMPLOYEE_SHIFT_MAPPING_LIST](state, data) {
    state.employeeShiftMappings = data || [];
  },
  [UNSET_EMPLOYEE_SHIFT_MAPPING_LIST](state) {
    state.employeeShiftMappings = [];
  },
  [SET_EMPLOYEE_SHIFT_MAPPING_DETAILS](state, data) {
    state.employeeShiftMappingDetails = data || null;
  },
  [UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS](state) {
    state.employeeShiftMappingDetails = null;
  },
};

const actions = {
  saveEmployeeShiftMapping({ commit }, payload) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveEmployeeShiftMapping, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeShiftMappingList({ commit }, params = {}) {
    const { __suppressCommit, ...queryParams } = params;
    return new Promise((resolve, reject) => {
      Axios.get(getEmployeeShiftMappingList, { params: queryParams })
        .then((response) => {
          if (!__suppressCommit) {
            commit(
              SET_EMPLOYEE_SHIFT_MAPPING_LIST,
              response?.data?.data ?? []
            );
          }
          resolve(response);
        })
        .catch((error) => {
          if (!__suppressCommit) {
            commit(UNSET_EMPLOYEE_SHIFT_MAPPING_LIST);
          }
          reject(error);
        });
    });
  },

  getEmployeeShiftMappingDetails({ commit }, id) {
    if (!id) {
      commit(UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS);
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      Axios.get(getEmployeeShiftMappingDetails(id))
        .then((response) => {
          commit(
            SET_EMPLOYEE_SHIFT_MAPPING_DETAILS,
            response?.data?.data ?? null
          );
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_SHIFT_MAPPING_DETAILS);
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

